import moment from 'moment'//导入文件
export default function (val, type = 'YYYY-MM-DD HH:mm:ss') {
  return val ? moment(val).format(type) : '　'
}
